import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    SettingType,
    Widget,
} from '@appblocks/codegeneration/types';
import BaseWidget, { sizes } from '@appblocks/codegeneration/Widgets/BaseWidget';

export default class ButtonWidget extends BaseWidget {
    constructor() {
        super();
        this.name = 'Button Widget';
        this.id = 'button_widget';
        this.minW = sizes[this.id].minW;
        this.minH = sizes[this.id].minH;

        const settings = this.getWidgetSettings(['VARIABLE', 'LABEL', 'BUTTON_LABEL', 'HAS_INPUT']);

        this.settings = this.settings.concat(settings);
    }

    setSettingValue(settingId: string, settingValue: any): void {
        if (settingId === 'HAS_INPUT') {
            if (settingValue === '1') {
                this.minH = 2;
            } else {
                this.minH = 3;
            }
        }
        super.setSettingValue(settingId, settingValue);
    }
}
